import { SubGroupConfiguration, MainGroupConfiguration } from "../../../data";
export const cmsConfig = {
    ShowTeamNameML: false,
    MainGroupBy: MainGroupConfiguration.Sport,
    SubGroupBy: SubGroupConfiguration.League,
    ExpandedMainGroupItems: 100,
    ExpandedGroupItems: 2,
    ExpandedEvents: 1,
    ShowSportEventsCount: true,
    ShowLeaguesEventsCount: true,
    ShowLivePhraseBeforeSportName: true,
    ShowSortingFilter: true,
    BlockId: "BlockId",
    BetRadarStatisticClientId: "1235",
    NumberOfSelectionsToShow: 5,
    EventsCount: 7,
    hasSettlementDate: true,
    SortIPTopLeaguesFirst: true,
    ShowViewAllLive: false,
    ShowLeagueInEventCard: true,
    ShowLiveFixturesAndOutrights: true,
    HideLowOdds: false,
    ShowStatisticsIcon: true,
    IsMBNEnabled: false,
    ShouldSortEventsByTime: true,
    NameSortSportIds: [],
    Locale: "",
    ShowViewMore: true
};
export const componentManagerConfig = {
    heights: {
        Subheading: { desktop: 38, mobile: 48 },
        LeagueInEventCard: { desktop: 20, mobile: 20 },
        ButtonInAmericanCard: { desktop: 26, mobile: 44 },
        ViewAllButtonContainer: { desktop: 55, mobile: 70 },
        AggregateCard: { desktop: 73, mobile: 73 },
        DefaultCard: { desktop: 60, mobile: 84 },
        AmericanCard: { desktop: 10, mobile: 64 },
        PreliveOutright: { desktop: 49, mobile: 48 },
        LiveOutright: { desktop: 54, mobile: 72 },
        DefaultMiniCard: { desktop: 56, mobile: 0 },
        MiniLiveOutright: { desktop: 36, mobile: 0 }
    },
    offsets: {
        Subheading: { desktop: 2, mobile: 1 },
        AggregateCard: { desktop: 4, mobile: 4 },
        DefaultCard: { desktop: 2, mobile: 2 },
        PreliveOutrightContainer: { desktop: 2, mobile: 2 },
        LiveOutright: { desktop: 2, mobile: 2 },
        DefaultMiniCard: { desktop: 2, mobile: 0 },
        ButtonInAmericanCard: { desktop: 2, mobile: 0 }
    }
};
//# sourceMappingURL=config.js.map